<template>
  <div id="videoPlayer" class="videoPlayer">
    <vue-aliplayer-v2
      :source="source"
      ref="VueAliplayerV2"
      :options="options"
    />
  </div>
</template>

<script>
export default {
  name: 'aliPlayer',

  props: {
    source: {
      type: String,
      require: true
    },
    status: {
      type: Number || String,
      require: true
    }
  },

  data() {
    return {
      options: {
        // 配置项 (options.source 不支持动态切换,需要动态切换请直接使用source)
        height: '100%',
        // source:'//player.alicdn.com/video/aliyunmedia.mp4',
        isLive: true // 切换为直播流的时候必填
        // format: 'm3u8'  //切换为直播流的时候必填
      }
      // source: '' // 播放源(此属性存在则优先于options.source) 支持动态切换,目前只支持同种格式（mp4/flv/m3u8）之间切换。暂不支持直播rtmp流切换。
      // source: '//ivi.bupt.edu.cn/hls/cctv1.m3u8',
    }
  },

  watch: {
    status: {
      handler(val) {
        if (Number(val) === 3) {
          this.options.isLive = false
        } else {
          this.options.isLive = true
        }
      },
      immediate: true
    }
  },

  mounted() {},

  methods: {
    play() {
      this.$refs.VueAliplayerV2.play()
    },

    pause() {
      this.$refs.VueAliplayerV2.pause()
    },

    // 重播
    replay() {
      this.$refs.VueAliplayerV2.replay()
    },

    // 切换直播模式和普通模式
    changeIsLive() {
      this.options.isLive = !this.options.isLive
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .prism-player .prism-cc-btn,
/deep/ .prism-player .prism-setting-btn {
  display: none !important;
}
.videoPlayer {
  position: relative;
  width: 100%;
  height: 100%;
}
* {
  margin: 0;
  padding: 0;
}
.remove-text {
  text-align: center;
  padding: 20px;
  font-size: 24px;
}
.show-multiple {
  display: flex;
  .multiple-player {
    width: calc(100% / 4);
    margin: 20px;
  }
}
.player-btns {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  span {
    margin: 0 auto;
    display: inline-block;
    padding: 5px 10px;
    width: 150px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #eee;
    background: #e1e1e1;
    border-radius: 10px;
    text-align: center;
    margin: 5px;
    cursor: pointer;
  }
}
.source-box {
  padding: 5px 10px;
  margin-bottom: 20px;
  .source-label {
    margin-right: 20px;
    font-size: 16px;
    display: block;
  }
  #source {
    margin-top: 10px;
  }
  .source-input {
    margin-top: 10px;
    padding: 5px 10px;
    width: 80%;
    border: 1px solid #ccc;
  }
}
</style>
